import { useState } from "react";
import { Layout, Menu, Button, Drawer, Dropdown, Flex } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
	MenuOutlined,
	DashboardOutlined,
	SettingOutlined,
	ShoppingCartOutlined,
	HistoryOutlined,
	UserOutlined,
	LogoutOutlined,
	ThunderboltOutlined,
} from "@ant-design/icons";
import useAuth from "../hooks/useAuth";
import NotificationModal from "../components/Modals/NotificationModal";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

const { Header, Content, Sider } = Layout;

const DashboardLayout = ({ children }) => {
	const [drawerVisible, setDrawerVisible] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const screens = useBreakpoint();

	const isSmall = !screens.md;
	const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);

	const toggleDrawer = () => setDrawerVisible(!drawerVisible);

	const menuItems = [
		{ key: "1", icon: <DashboardOutlined />, label: "Dashboard", link: "/" },
		{
			key: "2",
			icon: <ShoppingCartOutlined />,
			label: "Products",
			link: "/products",
		},
		{
			key: "5",
			icon: <ThunderboltOutlined />,
			label: "Bulk AI Generation",
			link: "/bulk-AI-generation",
		},
		{ key: "4", icon: <HistoryOutlined />, label: "History", link: "/history" },
		{
			key: "3",
			icon: <SettingOutlined />,
			label: "Settings",
			link: "/settings",
		},
	];
	const activeKey =
		menuItems
			.slice()
			.sort((a, b) => b.link.length - a.link.length)
			.find((item) => location.pathname.startsWith(item.link))?.key || "1";

	const handleMenuClick = (item) => {
		navigate(item.link);
	};

	return (
		<Layout style={{ minHeight: "100vh" }}>
			{/* Fixed Sidebar for large screens */}
			<Sider
				breakpoint="lg"
				collapsedWidth="0"
				className="hidden md:block"
				style={{
					position: "fixed",
					left: 0,
					top: 0,
					height: "100vh",
					zIndex: 999,
				}}
				width={200}
			>
				<div className="text-white text-center py-4 font-bold text-lg">
					SellBoost AI
				</div>
				<Menu
					theme="dark"
					mode="inline"
					selectedKeys={[activeKey]}
					items={menuItems.map((item) => ({
						...item,
						onClick: () => handleMenuClick(item),
					}))}
				/>
			</Sider>

			<Layout>
				{/* Main Layout that starts after sidebar width on large screens */}
				<Layout
					style={{
						background: "linear-gradient(135deg, #f8f9fc, #e9ecef)",
						marginLeft: 0,
					}}
				>
					{/* Header */}
					<AppHeader
						toggleDrawer={toggleDrawer}
						setIsNotificationModalOpen={setIsNotificationModalOpen}
					/>

					{/* Main Content */}
					<div
						style={{
							width: isSmall ? "100vw" : "calc(100vw - 200px)",
							marginLeft: isSmall ? "0px" : "200px",
							minHeight: "calc(100dvh - 64px)", // Subtract header height
							overflow: "hidden",
							overflowY: "auto",
						}}
					>
						<Content
							style={{
								margin: "0 auto",
								padding: isSmall ? "12px" : "24px",
								maxWidth: "1400px",

								height: "calc(100vh - 64px)", // Match parent height
							}}
						>
							<Outlet />
						</Content>
					</div>
				</Layout>
			</Layout>
			<NotificationModal
				isModalVisible={isNotificationModalOpen}
				setIsModalVisible={setIsNotificationModalOpen}
			/>
		</Layout>
	);
};

export default DashboardLayout;

const AppHeader = ({ toggleDrawer, setIsNotificationModalOpen }) => {
	const { logout } = useAuth();
	// Dropdown menu for logout
	const menu = (
		<Menu>
			<Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logout}>
				Logout
			</Menu.Item>
		</Menu>
	);

	return (
		<Header
			className="bg-white shadow-md flex justify-between items-center px-4"
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				position: "sticky",
				top: 0,
				zIndex: 1,
				width: "100%",
			}}
		>
			{/* Drawer Toggle Button (Visible only on Mobile) */}
			<div style={{ display: "flex", alignItems: "center", gap: "16px" }}></div>

			{/* Dropdown for Logout */}
			<Flex>
				<Dropdown overlay={menu} trigger={["click"]}>
					<Button
						type="text"
						icon={<UserOutlined style={{ color: "#FFF" }} />}
						style={{ color: "#000" }}
					/>
				</Dropdown>
			</Flex>
		</Header>
	);
};
